/* istanbul ignore file */

import { ApolloClient, HttpLink, ApolloLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import ApolloLinkTimeout from 'apollo-link-timeout';
import { cacheConfig } from '@americanexpress/banking-common/graphql';

const timeoutLink = new ApolloLinkTimeout(30000); // 30 second timeout
const timeoutHttpLink = (uri) =>
  timeoutLink.concat(
    new HttpLink({
      uri,
      credentials: 'include',
    })
  );

const cache = cacheConfig();

const createGraphQLClient = (graphApiUrl, dispatchAddErrorToReport) =>
  new ApolloClient({
    link: ApolloLink.from([
      onError((errors) => {
        const { graphQLErrors, networkError, operation } = errors;
        const { operationName, query, variables } = operation;
        if (graphQLErrors) {
          graphQLErrors.forEach(({ message, locations, path }) => {
            const error = {
              message,
              locations,
              operationName,
              path,
              query,
              variables,
            };
            dispatchAddErrorToReport(error, {
              collectionMethod: 'GraphQL error',
              moduleID: 'banking-root',
            });
          });
        }
        if (networkError) {
          dispatchAddErrorToReport(networkError, {
            collectionMethod: 'GraphQL timeout',
            moduleID: 'banking-root',
          });
        }
      }),
      timeoutHttpLink(graphApiUrl),
    ]),
    cache,
  });

export default createGraphQLClient;
